/* 全局getter，同时负责导出专家与用户专属getter */
export * from './expert/getters.expert';
export * from './user/getters.user';
export * from './nim/getters';

export const connectStatus = state => state.connectStatus;
export const error = state => state.error;
export const socket = state => state.socket;
export const signData = state => state.signData;
export const wxSignStatus = state => state.wxSignStatus;

export const isLoading = state => state.isLoading;
export const courseInfo = state => state.courseInfo;
export const courseCloseState = state => state.courseCloseState;

// socket message
export const currentMessages = state => state.messages;
export const latestMessage = state => state.latestMessage;
export const firstMessage = state => state.firstMessage;
export const sendMessages = state => state.sendMessages;
export const audioList = state => state.audioList;

// 获取当前播放的语音
export const lastPlayAudio = state => state.lastPlayAudio;
export const serialList = state => state.serialList;

// 收银台支付结果
export const cashierPayStatus = state => state.cashierPayStatus;




// WEBPACK FOOTER //
// ./src/store/getters.js